// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"88":"login-page","316":"register-page","811":"training-page","913":"library-page"}[chunkId] || chunkId) + "." + {"88":"6da4c4b8","316":"9cd78716","811":"20ad38ce","913":"5d163949","954":"d18e11d6"}[chunkId] + ".chunk.css";
};